import React, { useState } from 'react';
import AppInfo from './appInfo';
import DmtSetting from './dmtSetting';
import { Tabs } from 'antd';
import { SettingOutlined, DatabaseOutlined } from '@ant-design/icons';

function AppSetting(props) {
    const [activeTab, setActiveTab] = useState('1');

    const tabItems = [
        {
            key: '1',
            label: (
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <SettingOutlined />
                    <span>App Settings</span>
                </div>
            ),
            children: <AppInfo />,
        },
        {
            key: '2',
            label: (
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <DatabaseOutlined />
                    <span>DMT Settings</span>
                </div>
            ),
            children: <DmtSetting />,
        },
    ];

    return (
        <div style={{
            minHeight: '100vh',
            background: 'linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)',
            padding: '20px'
        }}>
            <div style={{
                maxWidth: '1400px',
                margin: '0 auto',
                background: 'white',
                borderRadius: '16px',
                overflow: 'hidden',
                boxShadow: '0 10px 40px rgba(0, 0, 0, 0.08)'
            }}>
                {/* Header */}
                {/* <div style={{
                    background: 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)',
                    padding: '30px 40px',
                    color: 'white'
                }}>
                    <h1 style={{ 
                        fontSize: '1.75rem', 
                        fontWeight: '700', 
                        margin: '0 0 8px 0'
                    }}>
                        Application Configuration
                    </h1>
                    <p style={{ 
                        margin: '0',
                        fontSize: '0.875rem',
                        opacity: '0.9'
                    }}>
                        Manage application and DMT settings
                    </p>
                </div> */}

                {/* Tabs */}
                <Tabs
                    activeKey={activeTab}
                    onChange={setActiveTab}
                    items={tabItems}
                    tabBarStyle={{
                        padding: '0 40px',
                        margin: '20px 0 0 0',
                        borderBottom: '1px solid #e2e8f0'
                    }}
                    size="large"
                />
            </div>
        </div>
    );
}

export default AppSetting;